  fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
      if (data.country_code === 'AU') {
        document.body.classList.add('region-australia');
      }
    });

// ==========================  Blog Search Filter start =========================== //
function filterApply(value, div) {
let title = document.querySelectorAll(".blog-post-title");
let searchValue = value.toLowerCase();
    title.forEach((e) => {
        let dataTitle = e.getAttribute("data-post-title").toLowerCase();
        let titleParentDiv = e.closest(".filter_box");
        if (titleParentDiv) {
        if (dataTitle.indexOf(searchValue) > -1) {
            titleParentDiv.classList.add("active");
        } else {
            titleParentDiv.classList.remove("active");
        }
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    let blockFilter = document.querySelector('[id^="filter-"]');
    if (blockFilter) {
        blockFilter.addEventListener("keyup", function () {
        filterApply(this.value, this.closest(".page-width"));
        });
    }
});
// ==========================  Blog Search Filter End =========================== //
// ==========================  Password View Function start =========================== //
const eyeClose = `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 64 64">
<path fill="none" stroke="var(--denary_color)" stroke-width="2" d="M1,32c0,0,11,15,31,15s31-15,31-15S52,17,32,17  S1,32,1,32z"/>
<circle fill="none" stroke="var(--denary_color)" stroke-width="2" cx="32" cy="32" r="7"/>
<line fill="none" stroke="var(--denary_color)" stroke-width="2" x1="9" y1="55" x2="55" y2="9"/>
</svg>`;
const eyeOpen = `<svg xmlns="http://www.w3.org/2000/svg" fill="var(--denary_color)" width="20px" height="20px" viewBox="0 0 60.254 60.254">
<g>
    <path d="M29.008,48.308c-16.476,0-28.336-17.029-28.833-17.754c-0.248-0.36-0.231-0.841,0.039-1.184c0.561-0.712,13.906-17.424,29.913-17.424
    c17.953,0,29.474,16.769,29.956,17.482c0.23,0.342,0.229,0.79-0.007,1.129c-0.475,0.688-11.842,16.818-29.899,17.721
    C29.786,48.297,29.396,48.308,29.008,48.308z M2.267,30.028c2.326,3.098,13.553,16.967,27.812,16.254
    c15.237-0.76,25.762-13.453,27.938-16.3c-2.175-2.912-12.811-16.035-27.889-16.035C16.7,13.947,4.771,27.084,2.267,30.028z"/>
    <path d="M30.127,37.114c-3.852,0-6.986-3.135-6.986-6.986c0-3.851,3.134-6.985,6.986-6.985s6.986,3.135,6.986,6.985
    C37.113,33.979,33.979,37.114,30.127,37.114z"/>
    <path d="M30.127,42.614c-6.885,0-12.486-5.602-12.486-12.486c0-6.883,5.602-12.485,12.486-12.485c6.884,0,12.486,5.602,12.486,12.485
    C42.613,37.012,37.013,42.614,30.127,42.614z M30.127,19.641c-5.782,0-10.486,4.704-10.486,10.486
    c0,5.781,4.704,10.485,10.486,10.485s10.486-4.704,10.486-10.485C40.613,24.345,35.91,19.641,30.127,19.641z"/>
</g>
</svg>`;
document.querySelectorAll(".toggle-password").forEach(function (toggleIcon) {
    toggleIcon.innerHTML = eyeClose;
    toggleIcon.addEventListener("click", function () {
        let inputField = this.previousElementSibling;
        if (inputField.type === "password") {
        inputField.type = "text";
        this.innerHTML = eyeOpen;
        } else {
        inputField.type = "password";
        this.innerHTML = eyeClose;
        }
    });
});
// ==========================  Password View Function End =========================== //
// ==========================  ®R Start =========================== //
document.querySelectorAll("body *:not(script, style, noscript)").forEach(el => {
    if (el.childNodes.length) {
        el.childNodes.forEach(node => {
            if (node.nodeType === 3 && node.nodeValue.includes("®")) {
                let newHTML = node.nodeValue.replace(/®/g, '<sup class="reg-mark">®</sup>');
                let wrapper = document.createElement("span");
                wrapper.innerHTML = newHTML;

                if (wrapper.innerHTML !== node.nodeValue) {
                    el.replaceChild(wrapper, node);
                }
            }
        });
    }
});
document.querySelectorAll(".reg-mark").forEach(mark => {
    let parent = mark.parentElement;
    let fontSize = window.getComputedStyle(parent).fontSize;
    let newSize = (parseFloat(fontSize) / 1.618) + "px";
    mark.style.fontSize = newSize;
    mark.style.position = "relative";
    mark.style.top = `-${parseFloat(newSize) / 2.2}px`; 
    mark.style.marginLeft = "1px"; 
});

// ================= Address form validation =====================================
document.addEventListener("DOMContentLoaded", function () {
        let inputField = document.querySelectorAll('.AddressName');
        inputField.forEach((input)=>{
            input.addEventListener("input", function () {
                if (/\d/.test(this.value)) {
                  this.value = this.value.replace(/\d/g, "");                 
                }
              });
        })
        let inputFieldNumber = document.querySelectorAll('.AddressNumber');
        inputFieldNumber.forEach((input)=>{
            input.addEventListener("input", function () {
                    if (/\D/.test(this.value)) {
                        this.value = this.value.replace(/\D/g, ""); 
                    }
        });
  });
});

  
// ==========================  ®R End =========================== //
document.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
        let selectedOptions = {};
        document.querySelectorAll('.product-form__input').forEach(fieldset => {
            let selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            let legend = fieldset.querySelector('legend');
            if (legend && selectedInput) {
                selectedOptions[legend.textContent.trim()] = selectedInput.value;
            }
        });
    });
});

// ==========================  Product sticky-bar start =========================== //
const quantity__button = document.querySelectorAll('sticky-bar quantity-input .quantity__button');
    quantity__button.forEach(function(e, val){
        e.addEventListener('click', (elm) => {
           document.querySelector('.block__selectoption-item quantity-input input').value =  elm.currentTarget.closest('quantity-input').querySelector('input').value
        }); 
    }); 
 
const productmainbutton = document.querySelector('sticky-bar .product-form__submit');
if (productmainbutton) {
  productmainbutton.addEventListener('click', () => {
        const submitButton = document.querySelector('.product-form__buttons .product-form__submit[type="submit"]');
        if (submitButton) {
            submitButton.click();
            setTimeout(() => {
                let sticky_bar_available =  document.querySelector('sticky-bar'); 
                if(sticky_bar_available){
                    document.querySelector('sticky-bar quantity-input input').value = 1; 
                }
            }, 1500)
        } 
    });
}
// ==========================  Product sticky-bar start End =========================== //

// ==========================  On scroll render section start  =========================== //
document.querySelectorAll(".template-sleeplab-design .block__scroll_sleep-study").forEach(function (el) {
    el.addEventListener("click", function (e) {
        e.preventDefault(); // This stops default link behavior (like reload)
        const target = document.getElementById("book-sleep-study");
        if (target) {
        target.scrollIntoView({ behavior: "smooth" });
        }
    });
});
// ==========================  On scroll render section End =========================== //


// =============================   Cart note validation start  =============================  //
document.getElementById('CartDrawer-Checkout').addEventListener('click', function(event) {
    event.preventDefault();
    if(document.getElementById('Details-CartDrawer').hasAttribute('open') && document.getElementById('CartDrawer-Note').value == ''){
       document.querySelector('cart-note span').style.display = 'block'; 
    }else{
      window.location.href = '/checkout'
    }
  }) 
// =============================   Cart note validation End  =============================  //

window.addEventListener('load', function(){
    if(window.innerWidth < 749){
        if(document.getElementById('main-collection-filters')){
            let header_height = document.querySelector('sticky-header').clientHeight; 
            document.getElementById('main-collection-filters').style.top = header_height + 'px';
        }
    }
})
// =============================   when scroll height increase announcement-bar-section add Class  Start =============================  //
window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY;
    const header = document.querySelector(".header-wrapper");
    const announcementBar = document.querySelector(".announcement-bar-section");

    if (announcementBar) {
        const announcementHeight = announcementBar.offsetHeight;
        const earlyOffset = 10;
        if (scrollTop >= (announcementHeight - earlyOffset) ) {
        header.classList.add("no-radius");
        } else {
        header.classList.remove("no-radius");
        }
    }
});
// =============================    when scroll height increase announcement-bar-section add Class  end  =============================  //

// =============================   move userway position to bottom in mobile start  =============================  //
 document.addEventListener('DOMContentLoaded', function () {
       function checkIsMobile() {
         if (window.innerWidth <= 768) { // Adjust the width as per your mobile breakpoint
             const elements = document.querySelectorAll('.userway_buttons_wrapper');

             elements.forEach(function (element) {
                 console.log("in top position");
                 element.style.removeProperty('top');
                 element.style.top = 'calc(85% + 5px)'; 
             });
         }
       }

       // Observe dynamically added elements
       const observer = new MutationObserver(function (mutationsList) {
           mutationsList.forEach(function (mutation) {
               if (mutation.type === 'childList') {
                   const elements = document.querySelectorAll('.userway_buttons_wrapper');
                   if (elements.length > 0) {
                       checkIsMobile(); // Reuse the existing method
                   }
               }
           });
       });
  
       // Start observing the body for changes
       observer.observe(document.body, { childList: true, subtree: true });

       // Check on window resize
       window.addEventListener('resize', function () {
           checkIsMobile();
       });
 });
// =============================   move userway position to bottom in mobile end  =============================  //
// =============================   Poer Review PDP Back To Top Start  =============================  //
document.addEventListener("click", function(e) {
  const backToTop = e.target.closest('.pr-rd-to-top');
  if (backToTop) {
    e.stopImmediatePropagation(); // stop PowerReviews default
    e.preventDefault();
    debugger;

    const target = document.querySelector('#pr-review-snapshot');
    if (target) {
      const headerOffset = 100;
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}, true);
// =============================   Poer Review PDP Back To Top End  =============================  //